/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S2_HeadingInputs */

const tr_mesafeli_s2_heading = /** @type {(inputs: Mesafeli_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Sözleşmenin Konusu ve Kapsamı`)
};

const en_mesafeli_s2_heading = /** @type {(inputs: Mesafeli_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Subject Matter and Scope of the Agreement`)
};

const de_mesafeli_s2_heading = /** @type {(inputs: Mesafeli_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Gegenstand und Umfang des Vertrages`)
};

const ru_mesafeli_s2_heading = /** @type {(inputs: Mesafeli_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Предмет и сфера действия Договора`)
};

/**
* | output |
* | --- |
* | "2. Subject Matter and Scope of the Agreement" |
*
* @param {Mesafeli_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s2_heading = /** @type {((inputs?: Mesafeli_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s2_heading(inputs)
	if (locale === "de") return de_mesafeli_s2_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s2_heading(inputs)
	return tr_mesafeli_s2_heading(inputs)
});